import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
import { addToFavoritesApi } from '../../util/api';
import { fetchCurrentUser } from '../../ducks/user.duck';
export const ASSET_NAME = 'landing-page';

export const addToFavorites = data => (dispatch, getState, sdk) => {
  return addToFavoritesApi(data).then(res => {
    // Refresh current user to get updated favorites in publicData
    dispatch(fetchCurrentUser({ enforce: true }));
    return res;
  });
};

export const loadData = (params, search) => dispatch => {
  const pageAsset = { landingPage: `content/pages/${ASSET_NAME}.json` };
  return dispatch(fetchPageAssets(pageAsset, true));
};
